export enum StorageKey {
    SessionId = 'dr_plg_session_id',
    OnboardingCompleted = 'dr_plg_onboarding_completed',
    SideNavbarMinimized = 'side_nav_bar_minimized',
    PlgToken = 'dr_plg_token',
    OnboardingStartedSent = 'dr_plg_onboarding_started_sent',
    OnboardingStartedAt = 'dr_plg_onboarding_started_at',
    /**
     * Set on PLG state reset (new/changed contact) to signal that the analytics
     * SDK must drop the previous contact's persisted Mixpanel identity before
     * re-init. Consumed + cleared by `AnalyticsSdkService.init()`.
     */
    AnalyticsIdentityReset = 'dr_plg_analytics_identity_reset',
    /**
     * The distinct_id we identified Mixpanel with (the first session id seen for
     * this contact). Durable so we identify exactly once — session_id can change
     * mid-flow (ERP change / re-bootstrap) and re-identifying an already-identified
     * anon id trips Mixpanel's `errAnonDistinctIdAssignedAlready`. Cleared only on
     * contact reset, in sync with the Mixpanel-persistence reset.
     */
    AnalyticsIdentified = 'dr_plg_analytics_identified',
    /**
     * Set once the HubSpot contact's email/name have been written to the Mixpanel
     * user profile (via people.set). Separate from `AnalyticsIdentified` because the
     * contact can arrive after the first identify. Cleared on contact reset.
     */
    AnalyticsProfileSet = 'dr_plg_analytics_profile_set',
}
